<template>
  <div v-on="$listeners">
    <v-tooltip top>
      <template v-slot:activator="{on}">
        <v-btn
          text
          icon
          :loading="loading"
          v-on="on"
        >
          <!-- TODO replace for mdi icons -->
          <v-icon
            :color="color"
          >
            {{ icon }}
          </v-icon>
        </v-btn>
      </template>
      <span v-if="tooltip">
        {{ tooltip }}
      </span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            required: true,
        },
        tooltip: {
            type: String,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        color: {
            type: String,
            default: null,
        },
    },
};
</script>
